import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ImportIconRendererComponent } from '@se/platform';
import { Logger, themeEstensa } from '@se/se.platform.base';
import { AllCommunityModule, CellClassParams, ColDef, GridOptions, GridReadyEvent } from 'ag-grid-community';

export interface ImportDialogData {
    data: any;
    columnDefs: ColDef[];
    callbackImportVisibility: (data: any) => boolean;
    callbackImport: (data: any) => void;
}

const STYLE_DISPLAY_NONE = { display: 'none' };
const STYLE_DISPLAY_INITIAL = { display: 'initial' };

@Component({
    selector: 'se-import-grid',
    templateUrl: './import-grid.component.html',
    styleUrls: ['./import-grid.component.scss'],
    standalone: false,
})
export class ImportGridComponent implements OnInit {
    gridHeight?: number;
    gridOptions: GridOptions = {};
    agGridModuls = [AllCommunityModule];
    agGridTheme = themeEstensa;

    constructor(
        @Inject(MAT_DIALOG_DATA) public dialogData: Partial<ImportDialogData> | undefined,
        private dialog: MatDialogRef<ImportGridComponent>,
        private logger: Logger,
    ) {}

    ngOnInit() {
        if (!this.dialogData || !this.dialogData.columnDefs || !this.dialogData.data) {
            this.logger.error('invalid import grid component confguration.');
            this.dialog.close();
            return;
        }
        /**@TODO  dalla versione 31 di ag-grid settare un valore di gridOption dopo che la griglia è stata creata non è più rilevato. da usare la funzione api.setGridOption (property, newValue)*/
        this.gridOptions.columnDefs = this.dialogData.columnDefs.concat(
            this.makeImportColumn(this.dialogData.callbackImportVisibility),
        );
        this.gridOptions.context = { callbackImport: this.dialogData.callbackImport };

        // 300px + 50px per ogni riga dei risultati, fino a 80vh
        this.gridHeight = Math.min(150 + this.dialogData.data.length * 50, (window.innerHeight / 100) * 80);
    }

    onClose() {
        this.dialog.close();
    }

    onGridReady(evt: GridReadyEvent) {
        evt.api.autoSizeAllColumns();
    }

    private makeImportColumn(visibilityCallback?: (data: any) => boolean): ColDef {
        return {
            colId: 'btnImport',
            headerName: '',
            valueGetter: (_) => '',
            suppressSizeToFit: true,
            resizable: false,
            lockPosition: true,
            pinned: 'right',
            cellStyle: visibilityCallback
                ? (p: CellClassParams) => (visibilityCallback(p.data) ? STYLE_DISPLAY_INITIAL : STYLE_DISPLAY_NONE)
                : STYLE_DISPLAY_INITIAL,
            cellRenderer: ImportIconRendererComponent,
        };
    }
}
